import React, { useEffect, useState } from 'react';
import Draggable from 'react-draggable';
import './DraggableModal.css';

const DraggableModal = ({
  children,
  title,
  isOpen,
  setIsOpen,
  startPosition,
  style,
  className
}) => {
  const [highlight, setHighlight] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      setHighlight(true);
      const timer = setTimeout(() => setHighlight(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const initialPositionStyle = {
    ...style,
    top: startPosition.top,
    left: startPosition.left,
    right: startPosition.right,
    bottom: startPosition.bottom,
  };

  return (
    <>
      {isOpen && (
        <Draggable cancel=".no-drag">
          <div
            className={`${className} fixed w-96 p-5 bg-white shadow-lg rounded-lg z-50 border-2 border-primary ${
              highlight ? 'highlight-animation' : ''
            }`}
            style={initialPositionStyle}
          >
            <div className="flex justify-between items-center border-b pb-2 mb-4">
              <h2 className="text-lg font-bold">{title}</h2>
              <button
                onClick={closeModal}
                className="text-2xl font-bold hover:text-red-600"
              >
                X
              </button>
            </div>
            <div className="modal-content">{children}</div>
          </div>
        </Draggable>
      )}
    </>
  );
};

export default DraggableModal;
